import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="mb-3 italic text-center">Rusa popola kanto-ludo</p>

      <p class="poem-block mb-3">
        Veturu ni, amata mia, vivi en vilaĝ’, <br/>
        Ekhavos ni propraĵon tie, estos bona aĵ’, <br/>
        Ekhavos ni, amata mia, kokineton, <br/>
        Kokineto trjuki-trjuki, <br/>
        Sur grenoj kokineto jam promenas!
      </p>

      <p class="poem-block mb-3">
        Veturu ni, amata mia, vivi en vilaĝ’, <br/>
        Ekhavos ni propraĵon tie, estos bona aĵ’, <br/>
        Ekhavos ni, amata mia, anaseton <br/>
        Anaseto krjaki-krjaki, <br/>
        Kokineto trjuki-trjuki, <br/>
        Sur grenoj kokineto jam promenas!
      </p>

      <p class="poem-block mb-3">
        Veturu ni, amata mia, vivi en vilaĝ’, <br/>
        Ekhavos ni propraĵon tie, estos bona aĵ’, <br/>
        Ekhavos ni, amata mia, ansereton, <br/>
        Ansereto gaki-gaki, <br/>
        Anaseto krjaki-krjaki, <br/>
        Kokineto trjuki-trjuki, <br/>
        Sur grenoj kokineto jam promenas!
      </p>

      <p class="poem-block mb-3">
        Veturu ni, amata mia, vivi en vilaĝ’, <br/>
        Ekhavos ni propraĵon tie, estos bona aĵ’, <br/>
        Ekhavos ni, amata mia, meleagron, <br/>
        Meleagro ŝuldi-buldi, <br/>
        Ansereto gaki-gaki, <br/>
        Anaseto krjaki-krjaki, <br/>
        Kokineto trjuki-trjuki, <br/>
        Sur grenoj kokineto jam promenas!
      </p>

      <p class="poem-block mb-3">
        Veturu ni, amata mia, vivi en vilaĝ’, <br/>
        Ekhavos ni propraĵon tie, estos bona aĵ’, <br/>
        Ekhavos ni, amata mia, ŝafineton, <br/>
        Ŝafineto ba-be, ba-be, <br/>
        Meleagro ŝuldi-buldi, <br/>
        Ansereto gaki-gaki, <br/>
        Anaseto krjaki-krjaki, <br/>
        Kokineto trjuki-trjuki, <br/>
        Sur grenoj kokineto jam promenas!
      </p>

      <p class="poem-block mb-3">
        Veturu ni, amata mia, vivi en vilaĝ’, <br/>
        Ekhavos ni propraĵon tie, estos bona aĵ’, <br/>
        Ekhavos ni, amata mia, kaprineton, <br/>
        Kaprineto meki-meki, <br/>
        Ŝafineto ba-be, ba-be, <br/>
        Meleagro ŝuldi-buldi, <br/>
        Ansereto gaki-gaki, <br/>
        Anaseto krjaki-krjaki, <br/>
        Kokineto trjuki-trjuki, <br/>
        Sur grenoj kokineto jam promenas!
      </p>

      <p class="poem-block mb-3">
        Veturu ni, amata mia, vivi en vilaĝ’, <br/>
        Ekhavos ni propraĵon tie, estos bona aĵ’, <br/>
        Ekhavos ni, amata mia, porkineton, <br/>
        Porkineto hrjuki-hrjuki, <br/>
        Kaprineto meki-meki, <br/>
        Ŝafineto ba-be, ba-be, <br/>
        Meleagro ŝuldi-buldi, <br/>
        Ansereto gaki-gaki, <br/>
        Anaseto krjaki-krjaki, <br/>
        Kokineto trjuki-trjuki, <br/>
        Sur grenoj kokineto jam promenas!
      </p>

      <p class="poem-block mb-3">
        Veturu ni, amata mia, vivi en vilaĝ’, <br/>
        Ekhavos ni propraĵon tie, estos bona aĵ’, <br/>
        Ekhavos ni, amata mia, bovineton, <br/>
        Bovineto muki-muki, <br/>
        Porkineto hrjuki-hrjuki, <br/>
        Kaprineto meki-meki, <br/>
        Ŝafineto ba-be, ba-be, <br/>
        Meleagro ŝuldi-buldi, <br/>
        Ansereto gaki-gaki, <br/>
        Anaseto krjaki-krjaki, <br/>
        Kokineto trjuki-trjuki, <br/>
        Sur grenoj kokineto jam promenas!
      </p>

      <p class="poem-block mb-3">
        Veturu ni, amata mia, vivi en vilaĝ’, <br/>
        Ekhavos ni propraĵon tie, estos bona aĵ’, <br/>
        Ekhavos ni, amata mia, ĉevaleton, <br/>
        Ĉevaleto igo-go-go, <br/>
        Bovineto muki-muki, <br/>
        Porkineto hrjuki-hrjuki, <br/>
        Kaprineto meki-meki, <br/>
        Ŝafineto ba-be, ba-be, <br/>
        Meleagro ŝuldi-buldi, <br/>
        Ansereto gaki-gaki, <br/>
        Anaseto krjaki-krjaki, <br/>
        Kokineto trjuki-trjuki, <br/>
        Sur grenoj kokineto jam promenas!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Veturu ni, amata mia, vivi en vilaĝ’'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['C_o9vGS7uN4'],
    itemTranslator: translator.esp
  }
}

export default item;